// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-share-update-request-table {
  width: 100%;
  border: 1px solid #d0d0d0;
  border-collapse: collapse;
  margin-top: 24px;
}
.songwriter-share-update-request-table th {
  background: #f0f0f0;
  text-align: left;
  padding: 12px 28px;
  font-weight: 700;
}
.songwriter-share-update-request-table td {
  padding: 18px 28px;
  vertical-align: middle;
}
.songwriter-share-update-request-table input {
  width: 62px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid transparent;
  background: transparent;
}
.songwriter-share-update-request-table input:not([readonly]) {
  border-color: #333;
  background: #fff;
}
.songwriter-share-update-request-table .share-error {
  margin-top: 6px;
  color: #d72b2b;
  font-size: 12px;
  line-height: 16px;
}

.add-cell-button,
.add-row-button .add-place-button {
  min-height: 84px;
  border: 1px dashed #d8d8d8;
  background: #fff;
}

.add-cell-button {
  width: 100%;
  color: #111;
  cursor: pointer;
}

.add-row-button {
  width: 87%;
  margin: 18px auto 0;
}

.add-cell-button span {
  display: block;
  margin: 0 auto 6px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e9e9e9;
  color: #2d5ab9;
  font-size: 26px;
  line-height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterWorkShareUpdateRequestScene/SongwriterWorkShareUpdateRequestTable/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;AACF;AACE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAEE;EACE,kBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;AADJ;AAIE;EACE,kBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAOA;;EAEE,gBAAA;EACA,0BAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,WAAA;EACA,eAAA;AAJF;;AAOA;EACE,UAAA;EACA,mBAAA;AAJF;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJF","sourcesContent":[".songwriter-share-update-request-table {\n  width: 100%;\n  border: 1px solid #d0d0d0;\n  border-collapse: collapse;\n  margin-top: 24px;\n\n  th {\n    background: #f0f0f0;\n    text-align: left;\n    padding: 12px 28px;\n    font-weight: 700;\n  }\n\n  td {\n    padding: 18px 28px;\n    vertical-align: middle;\n  }\n\n  input {\n    width: 62px;\n    height: 32px;\n    padding: 0 10px;\n    border: 1px solid transparent;\n    background: transparent;\n  }\n\n  input:not([readonly]) {\n    border-color: #333;\n    background: #fff;\n  }\n\n  .share-error {\n    margin-top: 6px;\n    color: #d72b2b;\n    font-size: 12px;\n    line-height: 16px;\n  }\n}\n\n.add-cell-button,\n.add-row-button .add-place-button {\n  min-height: 84px;\n  border: 1px dashed #d8d8d8;\n  background: #fff;\n}\n\n.add-cell-button {\n  width: 100%;\n  color: #111;\n  cursor: pointer;\n}\n\n.add-row-button {\n  width: 87%;\n  margin: 18px auto 0;\n}\n\n.add-cell-button span {\n  display: block;\n  margin: 0 auto 6px;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #e9e9e9;\n  color: #2d5ab9;\n  font-size: 26px;\n  line-height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
